import React from "react";
import { Button } from "../../../components/ui";
import { RefreshCw, Loader2, Filter } from "lucide-react";
import { SEGMENT_OPTIONS, STATUS_OPTIONS } from "../constants";

export default function FiltersBar({ 
  filters, 
  setFilters, 
  loading, 
  onRefresh, 
  onClearFilters 
}) {
  return (
    <div className="filters">
      <select value={filters.segment} onChange={(e)=>setFilters({...filters, segment: e.target.value})}>
        {SEGMENT_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <select value={filters.status} onChange={(e)=>setFilters({...filters, status: e.target.value})}>
        {STATUS_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <Button variant="outline" onClick={onRefresh} disabled={loading}>
        {loading ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Refreshing...
          </>
        ) : (
          <>
            <RefreshCw className="h-4 w-4 mr-2" />
            Refresh
          </>
        )}
      </Button>
      {(filters.segment || filters.status) && (
        <Button variant="outline" onClick={onClearFilters}>
          <Filter className="h-4 w-4 mr-2" />
          Clear Filters
        </Button>
      )}
    </div>
  );
}

